module.exports = __webpack_public_path__ + "static/img/main.ad05a49f.png";